import * as DATE from 'date-fns';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export var convertToRelativeTime = function convertToRelativeTime(end, t) {
  return function (start) {
    return pipe(DATE.differenceInSeconds(end, start), Math.abs, function (x) {
      return x < 60 ? O.some(t('now')) : O.none;
    }, O.alt(function () {
      return pipe(DATE.differenceInMinutes(end, start), Math.abs, O.fromPredicate(function (x) {
        return x < 60;
      }), O.map(function (minDiff) {
        return "".concat(minDiff, "m");
      }));
    }), O.getOrElse(function () {
      return "".concat(Math.abs(DATE.differenceInHours(end, start)), "h");
    }));
  };
};